import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { IconsModule } from '@platform-frontend/ui-tools';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { DesktopDrawerDialogComponent } from './desktop-drawer-dialog.component';
import { DesktopDrawerService } from './desktop-drawer-service';
import { MobileDrawDialogComponent } from './mobile-draw-dialog.component';

@NgModule({
  declarations: [DesktopDrawerDialogComponent, MobileDrawDialogComponent],
  imports: [CommonModule, IconsModule, TranslocoMarkupModule, TranslocoModule],
  exports: [DesktopDrawerDialogComponent, MobileDrawDialogComponent],
  providers: [DesktopDrawerService]
})
export class DrawDialogModule {}
